<template>
    <div>

        <v-row>
            <v-col align-self="center"
                   cols="3"
                   v-for="(grid,i) in layout"
                   :key="'grid'+i">
                <div v-if="typeof grid === 'object'">
                    <v-row v-for="(row,j) in grid"
                           :key="'col'+j">
                        <v-col align-self="center"
                               cols="6"
                               v-for="col in row"
                               :key="col">
                            <!-- loading placeholder -->
                            <v-skeleton-loader
                                class="mx-auto"
                                height="150"
                                type="card"
                                v-if="loading"
                             ></v-skeleton-loader>
                            <!-- loaded item -->
                            <GridTooltip v-else-if="item(col-1)"
                                         :item="item(col-1)">
                                <v-slide-y-transition>
                                    <Cover :src="getSrc(col-1)"
                                           @click="onClick(item(col-1))"
                                           :gradient="gradient && !item(col-1).canRead"/>
                                </v-slide-y-transition>
                            </GridTooltip>
                        </v-col>
                    </v-row>
                </div>
                <span v-else>
                    <!-- loading placeholder -->
                    <v-skeleton-loader
                                class="mx-auto"
                                height="300"
                                type="card"
                                v-if="loading"
                             ></v-skeleton-loader>
                    <!-- loaded item -->
                    <GridTooltip v-else-if="item(grid-1)"
                                 :item="item(grid-1)">
                        <v-slide-y-transition>
                            <Cover :src="getSrc(grid-1)"
                                   @click="onClick(item(grid-1))"
                                   :gradient="gradient && !item(grid-1).canRead"/>
                        </v-slide-y-transition>
                    </GridTooltip>
                </span>
            </v-col>
        </v-row>

    </div>
</template>

<script>

import Cover from '@/components/UI/Cover'
import GridTooltip from '@/components/Grids/GridTooltip'

export default 
{
   name: 'MosaicGrid',

   mixins: [],

   components:
   {
    Cover,
    GridTooltip
   },

   data: () => ({
     layout: [ 1, [ [ 2, 3 ], [ 4, 5 ] ], 6, [ [ 7, 8 ], [ 9, 10 ] ] ]
   }),

   props:
   {
      gradient:
      {
         type: Boolean,
         default: false
      },

      items:
      {
         type: Array,
         required: true,
         default: ()=> []
      },

      loading:
      {
         type: Boolean,
         default: false
      },

      prop:
      {
        type: String,
        default: 'cover'
      },
   },

   computed:
   {
     
   },

   methods:
   {
        getSrc(i)
        {
            let item = this.item(i)

            return (item && item[this.prop]) ? item[this.prop] : ''
        },

        item(i)
        {
            return typeof this.items[i] === 'undefined' ? null : this.items[i]
        },

        onClick(item)
        {
            this.$emit('click', item)
        }
   },

   load(){}
}
</script>